export const signinRedirect = ({ url, e, }) => {
    let el;
    if (url) {
        const baseURL = window.location.origin;
        const relativeUrl = url.startsWith('/');
        const stringUrl = relativeUrl ? new URL(url, baseURL) : new URL(url);
        el = stringUrl;
    }
    else {
        el = e === null || e === void 0 ? void 0 : e.element;
    }
    if (el.hostname.indexOf('signin') < 0) {
        const absoluteUrl = `${el.pathname}${el.search}${el.hash}`;
        el.href = `${process.env.SIGNIN_URL}/?path=${absoluteUrl}&forceLogin=true`;
    }
};
